module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-menu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-qq",
    attrs: {
      "to": "/helpList/在线反馈"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" "), _c('br'), _vm._v("在线反馈")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-qq",
    attrs: {
      "to": "/help"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" "), _c('br'), _vm._v("帮助中心\n  ")]), _vm._v(" "), _c('div', {
    class: ['btn', 'btn-top', _vm.visible ? '' : 'hidden'],
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  }), _vm._v(" "), _c('br'), _vm._v("TOP")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-qq",
    attrs: {
      "href": "http://wpa.qq.com/msgrd?v=3&uin=2850559846&site=qq&menu=yes",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-qq"
  }), _vm._v(" "), _c('br'), _vm._v("在线客服")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-phone"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" "), _c('br'), _vm._v("客服电话\n    "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("\n      0755-82405890")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-phone2"
  }, [_c('i', {
    staticClass: "fa fa-mobile-phone"
  }), _vm._v(" "), _c('br'), _vm._v("手机号码\n    "), _c('div', {
    staticClass: "phone2"
  }, [_vm._v("189-2386-5746(销售部)"), _c('br'), _vm._v("\n    189-2459-0809(采购部)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-phone3",
    attrs: {
      "href": "mailto:atm8123@spr-atm.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('br'), _vm._v("客服邮箱\n    "), _c('div', {
    staticClass: "phone3"
  }, [_vm._v("atm8123@spr-atm.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f14f2bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ToolBar.vue
// module id = 725
// module chunks = 0